import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { gql } from "@apollo/client"
import {Loading} from '../../../components/Loading/Loading'

import {
    Card,
    Grid,
} from '@material-ui/core'

//--------------------
import PeriodNavigator from '../../../components/PeriodPicker/PeriodNavigator'
import InfoIcon from '@material-ui/icons/Info'
import {
    Button,
    FormControl,
    Popper,
    Paper,
    Typography,
    ClickAwayListener,
} from '@material-ui/core'
//--------------------

import { quantityTransformer } from '../../../utils/tools'
import ExecutedAndBalanceChart from './ExecutedAndBalanceChart';
import ExpenseChart from './ExpenseChart';
import QuantityChart from './QuantityChart';
import ChangeReasonChart from './ChangeReasonChart';
import SumaryCard from './SumaryCard';
import BayphoneTable from './BayphoneTable';


const BAYPHONE_QUERIES = gql`
    query BayphoneBudgetStatistics($year: Int!) {
        bayphoneBudgetStatistics(year: $year) {
            startPeriod {
                date
            }
            endPeriod {
                date
            }
            currency {
                code
                symbol
            }
            periodStatistics {
                period {
                    date
                }
                deviceTypeStatistics {
                    deviceType
                    executedBudget
                    executedQuantity
                }
                changeReasonStatistics {
                    changeReason
                    executedBudget
                    executedQuantity
                }
                plannedBudget
            }
            totalPlannedBudget
            totalExecutedBudget
            executedBudgetDifference
        }
    }
`

function BayphoneDashBoard(props) {
    const { t } = useTranslation('bayphone')
    document.title = `${t('Bayphone Dashboard')} - BubbleBPM`

    const currentDate = new Date()

    const [period, setPeriod] = useState({ year: currentDate.getFullYear(), month: currentDate.getMonth() + 1 })

    const [anchorInfo, setAnchorInfo] = useState(null)

    function onChangePeriod(year, month) {
        setPeriod({ year: year, month: month })
    }

    function generateFilters() {
        return { year: period.year }
    }

    function generateTableFilters() {
        const monthString = (period.month < 10) ? "0" + Number(period.month) : period.month
        return { closedAt: `${period.year}-${monthString}` }
    }

    function generateExpensesSumaryCards(data) {
        if (!data || !data.bayphoneBudgetStatistics) {
            return [];
        }

        const { totalPlannedBudget, totalExecutedBudget, executedBudgetDifference } = data.bayphoneBudgetStatistics;

        const currencySymbol = data?.bayphoneBudgetStatistics?.currency?.symbol? data.bayphoneBudgetStatistics.currency.symbol : ''
        var differencePlannedColour = null;
        var differenceLabel = null;

        if (executedBudgetDifference > 0) {
            differencePlannedColour = "#2BB673";
            differenceLabel = t("Under budget");
        } else{
            differencePlannedColour = "#E94B3C";
            differenceLabel = t("Over budget");
        }

        return [
            {
                title: t("Budget"),
                value: `${currencySymbol} ${quantityTransformer(totalPlannedBudget, 2)}`,
            },
            {
                title: t("Executed Budget"),
                value: `${currencySymbol} ${quantityTransformer(totalExecutedBudget, 2)}`,
            },
            {
                title: differenceLabel,
                value: `${currencySymbol} ${quantityTransformer(Math.abs(executedBudgetDifference), 2)}`,
                color: differencePlannedColour,
            }
        ];
    }

    function generateChangeReasonExpensesSumaryCards(data) {
        if (!data || !data.bayphoneBudgetStatistics || !data.bayphoneBudgetStatistics.periodStatistics || data.bayphoneBudgetStatistics.periodStatistics.length === 0) {
            return [];
        }

        const symbol = data?.bayphoneBudgetStatistics?.currency?.symbol? data.bayphoneBudgetStatistics.currency.symbol : ''

        const changeReasonItems = {};
        data.bayphoneBudgetStatistics.periodStatistics.forEach((stat) => {
            stat.changeReasonStatistics.forEach((changeReasonStat) => {
                if (!changeReasonItems[changeReasonStat.changeReason]) {
                    changeReasonItems[changeReasonStat.changeReason] = 0;
                }
                changeReasonItems[changeReasonStat.changeReason] += changeReasonStat.executedBudget;
            });
        });

        const changeReasonCards = Object.entries(changeReasonItems).map(([changeReason, value]) => {
            return {
                title: changeReason,
                value: `${symbol} ${quantityTransformer(value, 2)}`,
                color: "#BAD6F7",
            };
        });

        return changeReasonCards;
    }

    function getExecutedPercentage(data) {
        if (!data || !data.bayphoneBudgetStatistics) {
            return 0;
        }
        const { totalPlannedBudget, totalExecutedBudget } = data.bayphoneBudgetStatistics;
        return totalPlannedBudget ? Math.min(Math.round(totalExecutedBudget / totalPlannedBudget * 100), 100) : 0;
    }

    function getMetaPercentage(data) {
        if (!data || !data.bayphoneBudgetStatistics) {
            return 0;
        }
        const { periodStatistics, totalPlannedBudget } = data.bayphoneBudgetStatistics;

        const partialPlaned = periodStatistics.reduce((sum, item) => {
            return sum + (item.plannedBudget || 0);
        }, 0);

        return Math.round(partialPlaned/totalPlannedBudget*100);
    }

    const handleInfo = (event) => {
        setAnchorInfo(event.currentTarget)
    }

    const handleCloseInfo = () => {
        setAnchorInfo(null)
    }

    return (
        <>
            <div>
                <Card style={{ marginTop: 5, marginBottom: 10 }}>
                    <FormControl style={{ width: "100%", paddingTop: 10, paddingBottom: 10 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: "100%", whiteSpace: 'nowrap' }}>
                            <div style={{ width: "3%" }}>
                                <Button
                                    onMouseLeave={handleCloseInfo}
                                    onMouseEnter={handleInfo}
                                    style={{ marginLeft: "1%" }}
                                    size='small'
                                >
                                    <InfoIcon />
                                </Button>
                            </div>
                            <div style={{ display: 'flex', width: "20%", maxHeight: 'fit-content' }}>
                                <span style={{ marginTop: '5px', color: '#0000008a' }}>{t('Period') + ': '}</span>
                                <PeriodNavigator
                                    style={{ marginLeft: 5 }}
                                    year={period.year}
                                    month={period.month}
                                    onChangePeriod={onChangePeriod}
                                />
                            </div>
                        </div>
                    </FormControl>
                </Card>
                <Popper open={Boolean(anchorInfo)} anchorEl={anchorInfo} placement="right-start">
                    <ClickAwayListener onClickAway={() => handleCloseInfo()}>
                        <Paper style={{ padding: 10 }}>
                            <Typography>{t("Monthly Bayphone report for Planned and Executed amounts")}</Typography>
                        </Paper>
                    </ClickAwayListener>
                </Popper>
            </div>
            <Loading query={BAYPHONE_QUERIES} variables={generateFilters()}>
                {(data) => {
                    if (!data?.bayphoneBudgetStatistics) return null;
                    return (
                        <div>
                            <Card id='bayphone_charts' style={{ marginTop: 5, marginBottom: 10, padding: 10 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: 5 }}>
                                            <div style={{display: "flex", justifyContent: "center", gap: "5px", marginTop: 5, marginBottom: 5, flexWrap: "none", width: "100%", height: "130px"}}>
                                                {generateExpensesSumaryCards(data).map((card, index) => (
                                                    <SumaryCard
                                                        key={index}
                                                        title={card.title}
                                                        value={card.value}
                                                        color={card.color}
                                                    />
                                                ))}
                                            </div>
                                            <div style={{ width: "100%", height: "80%" }}>
                                                <ExpenseChart
                                                    symbol={data?.bayphoneBudgetStatistics?.currency?.symbol? data.bayphoneBudgetStatistics.currency.symbol : ''}
                                                    presicion={2}
                                                    title={t("Expense by Device Type")}
                                                    t={t}
                                                    periodStatistics={data.bayphoneBudgetStatistics.periodStatistics}
                                                    onChangePeriod={onChangePeriod}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: 5 }}>
                                            <div style={{width: "100%", height: "130px", marginTop: 5, marginBottom: 5, }}>
                                                <ExecutedAndBalanceChart
                                                    executedPct={getExecutedPercentage(data)}
                                                    metaPct={getMetaPercentage(data)}
                                                    t={t}
                                                />
                                            </div>
                                            <div style={{ width: "100%", height: "80%" }}>
                                                <QuantityChart
                                                    periodStatistics={data.bayphoneBudgetStatistics.periodStatistics}
                                                    onChangePeriod={onChangePeriod}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <div style={{ padding: 5 }}>
                                            <div style={{display: "flex", justifyContent: "center", gap: "5px", marginTop: 5, marginBottom: 5, flexWrap: "none", width: "100%", height: "130px"}}>
                                                {generateChangeReasonExpensesSumaryCards(data).map((card, index) => (
                                                    <SumaryCard
                                                        key={index}
                                                        title={card.title}
                                                        value={card.value}
                                                        color={card.color}
                                                        icon={card.icon}
                                                        icontransform={card.icontransform}
                                                    />
                                                ))}
                                            </div>
                                            <div style={{ width: "100%", height: "80%" }}>
                                                <ChangeReasonChart
                                                    symbol={data?.bayphoneBudgetStatistics?.currency?.symbol? data.bayphoneBudgetStatistics.currency.symbol : ''}
                                                    periodStatistics={data.bayphoneBudgetStatistics.periodStatistics}
                                                    onChangePeriod={onChangePeriod}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Card>
                            <BayphoneTable title={"Bayphone"} filters={generateTableFilters()} />
                        </div>
                    )
                }}
            </Loading>
        </>
    )
}

export default BayphoneDashBoard;
